export default __webpack_public_path__ + "locales/pt/FillPDFDialog.json?hash=4b688d7ba9301505ed41954b9896cfa5";